'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Qualaroo = exports.Qualaroo = function () {
  function Qualaroo() {
    _classCallCheck(this, Qualaroo);
  }

  _createClass(Qualaroo, null, [{
    key: 'inject',
    value: function inject(id) {
      window._kiq = window._kiq || [];
      var d = document,
          f = d.getElementsByTagName('script')[0],
          s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = '//s3.amazonaws.com/ki.js/' + id + '/fUI.js';
      f.parentNode.insertBefore(s, f);
      return s;
    }
  }, {
    key: 'initialize',
    value: function initialize(_ref) {
      var clientId = _ref.clientId,
          userId = _ref.userId,
          userCreatedDate = _ref.userCreatedDate;
      var client = window._kiq;

      if (client === undefined) {
        Qualaroo.inject(clientId);
        client = window._kiq;
      }

      if (userId !== undefined) {
        client.push(['identify', '' + userId]);
        client.push(['set', {
          created_date: '' + userCreatedDate
        }]);
      }
    }
  }, {
    key: 'setProperties',
    value: function setProperties(properties) {
      var client = window._kiq;

      if (client === undefined) {
        return;
      }

      client.push(['set', properties]);
    }
  }]);

  return Qualaroo;
}();